module.exports = __webpack_public_path__ + "static/media/event-services-img3.a1c80cec.jpg";